export default {
    confirming: {
        confirmedOrder: 'Не все позиции согласованы',
        totalSum: 'Сумма собранных товаров равна нулю',
        canBeAgreed: 'Заказ может быть согласован',
    },

    confirmingDelivery: {
        confirmedOrder: 'Не все позиции согласованы',
        totalSum: 'Сумма собранных товаров равна нулю',
        minSum: 'Заказ на сумму менее {minSum} рублей не может быть согласован',
        completePackage: 'Не указана упаковочная тара',
        canBeAgreed: 'Заказ может быть согласован',
    },

    formationDelivery: {
        allProductsOutOfStock: `Для отмены заказа нажмите "Сформировать" (всех товаров нет в наличии)`,
        emptyProducts: 'Необходимо собрать хотя бы один товар или отменить заказ',
        // eslint-disable-next-line max-len
        noCollected: 'Невозможно собрать заказ, пока количество заказанных и количество собранных товаров не сравняются, или пока не будет указана причина изменения несобранной позиции',
        completePackage: 'Не указана упаковочная тара',
        update: 'Обновляется информация о товарах',
        ready: 'Заказ готов к сборке',
        tare: 'Необходимо указать вес для каждой упаковочной тары!',
        tareWeight: 'Общий вес всех товаров не должен превышать {weight} кг',
        tareWeightSingle: 'Вес короба больше допустимого. Удалите текущий короб или переложите часть позиций в другой короб',
    },

    formatting: {
        // eslint-disable-next-line max-len
        noCollected: 'Невозможно собрать заказ, пока количество заказанных и количество собранных товаров не сравняются, или пока не будет указана причина изменения несобранной позиции',
        // eslint-disable-next-line max-len
        noCollectedWithoutPacket: 'Невозможно собрать заказ, пока количество заказанных товаров и количество собранных товаров не сравняются, или пока не будет указана причина изменения несобранной позиции, или пока не будет добавлен хотя бы 1 пакет',
        update: 'Обновляется информация о товарах',
        ready: 'Заказ готов к сборке',
    },
};